import * as msal from '@azure/msal-browser';
import { msalLoggerCallback } from './msal.logger.callback';

export const msalConfig: msal.Configuration = {
  auth: {
    clientId: '08848fc8-896a-470f-9a29-ea596e965ae1',
    authority: 'https://login.microsoftonline.com/6f4d03de-9551-4ba1-a25b-dce6f5ab7ace/',
    redirectUri: 'https://accesshub.abbvie.com/logged-in.html',
    postLogoutRedirectUri: 'https://accesshub.abbvie.com/logged-out.html',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: msal.BrowserCacheLocation.LocalStorage
  },
  system: {
    loggerOptions: {
      logLevel: msal.LogLevel.Info,
      piiLoggingEnabled: true,
      loggerCallback: msalLoggerCallback
    }
  }
};

export interface Environment {
  production: boolean;
  msalConfig: msal.Configuration;
  scopes: string[];
  siteUrl: string;
  serverUrl: string;
  version: string;
  environment: string;
  tenantName: string;
  authenticationInteractionMode: 'Redirect' | 'Popup';
}

export const environment: Environment = {
  production: true,
  msalConfig,
  siteUrl: 'https://abbvie.sharepoint.com/teams/AccessHub',
  serverUrl: 'https://abbvie.sharepoint.com',
  scopes: [
    'https://abbvie.sharepoint.com/.default'
  ],
  version: "3.16.2",
  environment: "Prod",
  tenantName: "Abbvie",
  authenticationInteractionMode: 'Popup'
};

